// stats for tips for you balthazar experiment
export const listViewedEvent = ({ listID, listType }) => {
    return {
        name: 'svtplay-list-viewed',
        eventValues: {
            listID,
            listType,
        },
    };
};

export const listInViewEvent = ({ listID, listType }) => {
    return {
        name: 'svtplay-list-in-view',
        eventValues: {
            listID,
            listType,
        },
    };
};

// stats for fullwidth experiment
export const browserWidth = (browserwidth) => ({
    name: 'svtplay-browser-width',
    eventValues: {
        browserWidth: browserwidth.browserWidth,
        browserHeight: browserwidth.browserHeight,
        screenWidth: browserwidth.screenWidth,
        screenHeight: browserwidth.screenHeight,
        screenPixelRatio: browserwidth.screenPixelRatio,
    },
});

// AB Personalized genres oct 2020
export const hasHistory = (historyValue) => {
    return {
        name: 'svtplay-hasHistory',
        eventValues: {
            hasHistory: historyValue,
        },
    };
};
